import { forwardRef } from 'react';
import type { BusinessIconImageProps } from '../businessTypes';

type AnalyticsFilledProps = BusinessIconImageProps & {
  secondaryColor?: string;
};

const AnalyticsFilled = forwardRef<SVGSVGElement, AnalyticsFilledProps>(
  ({ size = 24, width, height, alt = '', color = 'currentColor', secondaryColor = '#fff', strokeWidth, style, ...props }, ref) => (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill={color}
      strokeWidth={strokeWidth}
      width={width ?? size}
      height={height ?? size}
      role={alt ? 'img' : undefined}
      aria-label={alt || undefined}
      aria-hidden={alt ? undefined : true}
      style={{ color, ...style }}
      {...props}
    >
      <g transform="translate(-5.25 -5.250187) scale(0.71875)">
        <path d="M33.0114 36.0117C33.64 36.0117 34.1543 36.526 34.1543 37.1546C34.1543 37.7831 33.6457 38.2974 33.0171 38.2974H14.9829C14.3543 38.2974 13.84 37.7831 13.84 37.1546C13.84 36.526 14.3543 36.0117 14.9829 36.0117H33.0114ZM37.7143 9.70312C38.9771 9.70312 40 10.726 40 11.9888V31.2003C40 32.4631 38.9771 33.486 37.7143 33.486H10.2857C9.02286 33.486 8 32.4631 8 31.2003V11.9888C8 10.726 9.02286 9.70312 10.2857 9.70312H37.7143ZM33.5831 15.4343C33.0657 15.0202 32.3105 15.104 31.8964 15.6215L26.0919 22.8745L20.8576 18.3284L20.8239 18.3001C20.2901 17.869 19.4986 17.9727 19.0954 18.5353L15.3813 23.7172L15.3564 23.7534C15.001 24.289 15.1309 25.0141 15.6576 25.3916L15.6938 25.4166C16.2294 25.772 16.9545 25.642 17.332 25.1153L20.2786 21.0042L25.4613 25.5058L25.4953 25.5342C26.0099 25.9495 26.7685 25.8703 27.1851 25.3496L33.7703 17.121L33.7971 17.0862C34.1804 16.5702 34.0891 15.8392 33.5831 15.4343Z" />
      </g>
    </svg>
  ),
);

AnalyticsFilled.displayName = 'AnalyticsFilled';

export default AnalyticsFilled;
